import React from "react";
import {
  LocalizationProvider,
  DatePicker as MUIDaterPicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Moment } from "moment";
import { SxProps } from "@mui/material";

type DatePickerProps = {
  onChange: (date: Moment) => void;
  value?: Moment;
  defaultValue?: Moment;
  disabled?: boolean;
  label?: string;
  sx?: SxProps;
};

export const DatePicker: React.FC<DatePickerProps> = (props) => {
  const {
    onChange,
    value,
    defaultValue,
    disabled = false,
    sx = {},
    label = "Enter date here...",
  } = props;

  const handleChange = (value: Moment) => {
    onChange(value);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MUIDaterPicker
        label={label}
        value={value}
        defaultValue={defaultValue}
        onChange={handleChange}
        disabled={disabled}
        sx={{ minWidth: "150px", ...sx }}
        slotProps={{
          textField: {
            size: "small",
            error: false,
          },
        }}
      />
    </LocalizationProvider>
  );
};
